import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../VabSideBar/logo.png';

const _withScopeId = n => (_pushScopeId("data-v-4b7794ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "logo"
}, [/*#__PURE__*/_createCommentVNode(" 使用自定义svg示例 "), /*#__PURE__*/_createElementVNode("img", {
  height: "44px",
  src: _imports_0,
  width: "44px"
}), /*#__PURE__*/_createCommentVNode(" <vab-icon v-if=\"logo\" :icon=\"logo\" is-custom-svg /> ")], -1
/* HOISTED */
));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["logo-container", {
      ['logo-container-' + $setup.theme.layout]: true
    }])
  }, [_createVNode(_component_router_link, {
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_1, _createElementVNode("span", {
      class: _normalizeClass(["title", {
        'hidden-xs-only': $setup.theme.layout === 'horizontal'
      }])
    }, _toDisplayString($setup.title), 3
    /* TEXT, CLASS */
    )]),
    _: 1
    /* STABLE */

  })], 2
  /* CLASS */
  );
}